import { render, staticRenderFns } from "./FileAndPhotos.vue?vue&type=template&id=18286a76&scoped=true&"
import script from "./FileAndPhotos.vue?vue&type=script&lang=js&"
export * from "./FileAndPhotos.vue?vue&type=script&lang=js&"
import style0 from "./FileAndPhotos.vue?vue&type=style&index=0&id=18286a76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18286a76",
  null
  
)

export default component.exports